import { createContext, useContext } from "react"

const TRAILING_DOLLAR_SUFFIX = /\s*\(\$\)$/

export function buildScaledCurrencyLabel(label: string, currencyScale: string | null): string {
  if (!currencyScale) return label

  const scaleSuffix = `($${currencyScale})`
  return TRAILING_DOLLAR_SUFFIX.test(label)
    ? label.replace(TRAILING_DOLLAR_SUFFIX, ` ${scaleSuffix}`)
    : `${label} ${scaleSuffix}`
}

const CurrencyScaleContext = createContext<string | null>(null)

export const CurrencyScaleProvider = CurrencyScaleContext.Provider

interface CurrencyScaledLabelProps {
  label: string
}

export function CurrencyScaledLabel({ label }: CurrencyScaledLabelProps) {
  const currencyScale = useContext(CurrencyScaleContext)
  return buildScaledCurrencyLabel(label, currencyScale)
}
